import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import styles from "@/components/state-change/state.module.css";
import jiraAbledIcon from "@/assets/img/jiraAbleIcon.svg";
import { InputFields } from "@/components/state-change/helper";
import AcceptJiraTable from "./accept-jira-table";
import ModalTable from "@/page-components/snapshot/components/modal/modalTable";
import closeButton from "@/assets/img/closecross.svg";
import AcceptJiraTableRecopmmendation from "@/page-components/cost-Recommendation/component/jiraTable";

/** @typedef {import('@/services/snapshots/addAcceptFields.repo').UpdateAcceptRecommendationsReq} UpdateAcceptRecommendationsReq */

/**
 * @typedef IAcceptStatusReq
 * @property {string} comment
 */

const AcceptStatusReq = Joi.object({
  comment: Joi.string().required().min(3).messages({
    "string.empty": "Description is required",
    "string.min": "Description must be at least 3 characters",
  }),
});

/**
 * @typedef AcceptViaJiraProps
 * @property {boolean} show
 * @property {VoidFunction} handleClose
 * @property {(values: IAcceptStatusReq) => void} onSubmit
 */

/**
 * @param {AcceptViaJiraProps} props
 */
const AcceptViaJira = ({
  Itsm_type,
  type,
  show,
  handleClose,
  onSubmit,
  name,
  selectedRows,
  updateStatusPending,
  table_account,
}) => {
  // const [updatedSelectedRows, setUpdatedSelectedRows] = useState(
  //   selectedRows || []
  // );

  const formData = useForm({
    resolver: joiResolver(AcceptStatusReq),
    defaultValues: { comment: "" },
  });

  const handleCancel = () => {
    formData.reset();
    handleClose();
  };

  const handleFormSubmit = (data) => {
    const filteredResources = selectedRows.map((resource) => ({
      resourceId: resource.resource_id || "",
      accountName: resource.account_name || "",
      resourceName: resource.name || resource.idle_resource_name || "",
      resourceCost: resource.saving || 0,
      accountId: resource.account_id || resource.project_id || "",
    }));
    const payload = {
      comment: data.comment,
      selectedRows: filteredResources,
    };
    onSubmit(payload);
    formData.reset();
  };
  return (
    <Offcanvas
      show={show}
      onHide={handleCancel}
      placement="end"
      // backdrop="static"
      className={styles.offcanvas_main}
    >
      <Offcanvas.Header className={styles.offcanvas_header_main}>
        <div className={styles.retain_close}>
          <div className={styles.offcanvas_header}>
            <div className={styles.accept_via_jira}>
              {Itsm_type==="jira"&&(
              <img
                src={jiraAbledIcon}
                alt="Accept via Jira"
                style={{ marginRight: "4px" }}
              />
              )}
              Accept via {Itsm_type}
            </div>
            <div className={styles.header_desc}>
              <span className={styles.accept_recommend}>
                Accept {name} Recommendation
              </span>
              <span className={styles.accpt_desc}>
                Add details to accept the recommendations.
              </span>
            </div>
          </div>
          <img
            src={closeButton}
            alt="Close"
            onClick={handleCancel}
            style={{ cursor: "pointer" }}
          ></img>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body className={styles.offcanvas_body_css}>
        <form
          onSubmit={formData.handleSubmit(handleFormSubmit)}
          className={styles.contentContaineredBox}
        >
          <div className={styles.body_content}>
            <div>
              <div className={styles.comment_boxed}>
                <Controller
                  name="comment"
                  control={formData.control}
                  render={({ field }) => (
                    <InputFields
                      tittle={"Description"}
                      symbol={"*"}
                      placeholder={"Add Description"}
                      {...field}
                      textValue={field.value}
                      textChange={field.onChange}
                    />
                  )}
                />
                {formData.formState.errors.comment && (
                  <p className={styles.errorMessage}>
                    {formData.formState.errors.comment.message}
                  </p>
                )}
              </div>

              <div className={styles.table_main}>
                {name === "Snapshots" && <ModalTable name={type} />}
                {name === "Recommendation" && <AcceptJiraTableRecopmmendation name={type} />}
                {name === "Idle Resource" && (
                  <AcceptJiraTable
                    selectedRows={selectedRows}
                    table_account={table_account}
                    // selectedRows={updatedSelectedRows}
                    // onRowsChange={setUpdatedSelectedRows}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.buttonsContainered}>
            {/* <div></div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "4px",
              }}
            >
              <button
                id={styles.AcceptId}
                className={styles.cancleButton}
                onClick={handleCancel}
                type="button"
              >
                Cancel
              </button>
              <button
                id={styles.AcceptId}
                className={styles.submitButton}
                // onClick={handleSubmit}
                type="submit"
              >
                {updateStatusPending ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Loading...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AcceptViaJira;
